
<template>
  <div>
    <div class="container link">
      <div class="list ellipsis">
      <div class="li title" v-for="(adv,index) in ggw3picsrc" :key="index"><a :href="adv.url" target="_blank" ><img :src="`${global.remoteIp}/uploads/${adv.picsrc}`"/></a></div>
    </div>
		</div>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {
    plates: Array,
    platename: String,
  },
  components: {},
  data() {
    return {
      articles: [],
      plateId: "",
      global,
      ggw3picsrc:[]
    };
  },
  mounted() {
    this.$axios.get("/api/advertises").then((res) => {
      let advs = [];
      if (res.data) {
        advs = res.data.data;
        for (let i = 0; i < advs.length; i++) {
          if (advs[i].position == "友情链接上方") {
            this.ggw3picsrc.push(advs[i]);
          }
        }
      }
    });
    
  },
};
</script>
<style scoped>

.ellipsis .title{
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.link{
	padding: 25px 0;
}
.link .list{
	display: flex;
	flex-wrap: wrap;
}
.link .li{
	width: 33%;
	font-size: 13px;
	color: #6a6a6a;
	line-height: 42px;
	/* padding-left: 20px; */
	box-sizing: border-box;
}
.link .li a{
  line-height: 30px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    margin-left: 12px;
}
</style>
